export default __webpack_public_path__ + "static/media/illustration-features-tab-1.0da3d302.svg";